import {style, animate, trigger, transition, state} from '@angular/animations';

export const openCloseAnimation = trigger('openedAnimation', [
  state('opened', style({
    height: '*',
    visibility: 'visible',
    overflow: 'hidden'
  })),
  state('closed', style({
    height: '0px',
    visibility: 'hidden',
    overflow: 'hidden'
  })),
  transition('opened <=> closed', [
    animate('0.5s ease')
  ])
]);
